import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { el } from "../lib/dom";
import { sectionCover } from "../lib/sectionCover";
import { wedding, venue } from "../content/site";
import { photos } from "../content/photos.generated";
import { mapsHref, mapPin } from "../lib/maps";
import { buzz } from "../lib/haptics";

interface ItemRow {
  label: string;
  value: string;
  sub?: string;
  /** Optional in-row CTA — renders below the sub/value. */
  cta?: { label: string; href: string; targetBlank?: boolean };
}

export function renderDay(root: HTMLElement) {
  const page = el("section", { class: "page", id: "dag" });

  page.appendChild(
    sectionCover({
      title: "Ons Groot Dag",
      photo: photos.gallery[4] ?? photos.gallery[0] ?? null,  // IMG_4706
      bgPosition: "25% center",                                // shift right (reveal left of image where the couple is)
    }),
  );

  const content = el("div", { class: "page__content groot-dag__content" });

  // Big date as the anchor
  content.appendChild(
    el(
      "h3",
      { class: "groot-dag__date" },
      `${wedding.weekday}, ${wedding.dateLabel}`,
    ),
  );

  const list = el("div", { class: "groot-dag" });
  const items: ItemRow[] = [
    { label: "Seremonie", value: `14:30 vir ${wedding.time}` },
    { label: "Onthaal", value: "Volg na die seremonie" },
    {
      label: "Plek",
      value: venue.name,
      sub: venue.city,
      cta: { label: "Padkaart", href: mapsHref(), targetBlank: true },
    },
    { label: "Kleredrag", value: "Semi-Formeel" },
    { label: "RSVP", value: `Voor ${wedding.cutoffLabel}` },
  ];
  for (const item of items) {
    const row = el(
      "div",
      { class: "groot-dag__item" },
      el("p", { class: "groot-dag__label" }, item.label),
      el("p", { class: "groot-dag__value" }, item.value),
    );
    if (item.sub) row.appendChild(el("p", { class: "groot-dag__sub" }, item.sub));
    if (item.cta) {
      const btn = el(
        "a",
        {
          class: "padkaart",
          href: item.cta.href,
          ...(item.cta.targetBlank
            ? { target: "_blank", rel: "noopener noreferrer" }
            : {}),
          "data-cursor-label": "Open kaart",
        },
        mapPin(),
        el("span", {}, item.cta.label),
      );
      btn.addEventListener("click", () => buzz("tap"));
      row.appendChild(btn);
    }
    list.appendChild(row);
  }
  content.appendChild(list);

  page.appendChild(content);
  root.appendChild(page);

  gsap.from(list.children, {
    opacity: 0,
    y: 16,
    duration: 0.6,
    stagger: 0.08,
    ease: "power2.out",
    scrollTrigger: { trigger: list, start: "top 85%" },
  });
  ScrollTrigger.refresh();
}
